import * as React from "react";
import { ArticleGW } from "./ArticleGW"
import { BDKalkCore } from "./BDKalkCore"
import { ExtInfoViewGW } from "./ExtInfoViewGW"
import { ChoiseControlQreportGW } from "./ChoiseControlQreportGW"
import { PADebug } from "./PADebug"

///////////////   SelectionItemGW  ////////////////

export interface SelectionItemVm {
    article: ArticleGW
    core: BDKalkCore
}

export interface SelectionItemStates {
    mouseState: string,
    inputActive: boolean
}

/** SelectionItemGW is the controller class for the articles enlisted within the quick report.
 *  Each item holds a reference to an instance of AtricleGW, which may be shared with list items
 *  within the ArticleViewGW and/or the favorites list. Each SelectionItemGW also has a numeric
 *  control object of type ChoiseControlQreportGW which is displayed on the left side of each
 *  item and with which the user can edit the amount for each chosen article.   */
export class SelectionItemGW extends React.Component<SelectionItemVm, SelectionItemStates> {

    state: SelectionItemStates = {
        mouseState: "out",
        inputActive: false
    }

    GetInputActive() {
        var coreItem = this.props.core.GetInputItemSel()
        if (coreItem == null) {
            return false
        }
        else {
            if (coreItem.GetArticle().GetSelectionLabel() == this.GetArticle().GetSelectionLabel()) {
                return true
            }
            else {
                return false
            }
        }
    }

    // Referencing of the amount seting device for this item (which is called by itself on initiation)
    ConnectChoise(choiseCtr: ChoiseControlQreportGW) {
        this.m_choise = choiseCtr
        this.m_clickedArea = "none"
    }

    // Mouse up handler
    onMouseUp() {
        this.setState({ mouseState: "hover" })
        this.m_choise.setState({ hovering: true })
    }

    // Mouse out handler
    onMouseOut() {
        if (this.GetInputActive() == false) {
            this.setState({ mouseState: "out" })
            this.m_choise.setState({ hovering: false })
            this.m_choise.setState({ plusPressed: false })
            this.m_choise.setState({ minusPressed: false })
            this.m_choise.setState({ crossPressed: false })
        }
        else {
            this.setState({ mouseState: "out" })
        }
    }

    // Sets the amount to a new value and forces the affected displays to redraw instantly
    SetAmount(newAmount: number) {
        this.props.article.SetAmount(newAmount)
        this.forceUpdate()
        this.props.core.RedrawTotalSum()
    }

    // Mouse over handler
    onMouseOver() {
        this.setState({ mouseState: "hover" })
        this.m_choise.setState({ hovering: true })
    }

    // Mouse down (pressed) handler
    onMouseDown() {
        this.setState({ mouseState: "hover" })
    }

    // Access method - gives a reference to the article displayed by this selection item
    GetArticle() {
        return this.props.article
    }

    // Handler for when the favorites (star) button of this item is clicked
    onClickFavorites() {
        this.m_clickedArea = "favorites"
    }

    // Mouse click handler
    onClick() {
        const area = this.m_clickedArea
        this.m_clickedArea = "none"
        this.props.core.HandleQRItemClick(this, area)
        // this.props.core.SelectQreportArticle(this.props.article, this)
    }

    // Mouse click handler for the central parts which should cause Ext info to toggle when selected
    onClickCenter() {
        if (this.props.core.GetApp().IsArticleSelected(this.props.article.GetSelectionLabel()) == true) {
            this.props.core.GetApp().ToggleExtInfo()
        }
    }

    // Returns true if the article held by this item is the one currently selected within the application
    isSelected() {
        if (this.props.core.GetApp().GetSelectionID() == this.props.article.GetSelectionLabel()) {
            return true
        }
        else {
            return false
        }
    }

    // SetLocation is used internally by sub controls to specify where the item has been clicked
    SetLocation(location: string) {
        this.m_clickedArea = location
    }

    // Rendering the article item as it should be displayed within the quick report view
    render() {
        var art = this.props.article

        // Hovering or selecting the item will cause it to render with some visual differences, and hoverstyle (below) holds the final set of characteristics to be rendered
        var hoverstyle: React.CSSProperties = { width: '100%', height: '31px', display: 'flex', flexDirection: 'row', borderTop: '1px solid white', borderBottom: '1px solid white' }
        var hoverstyle_hover: React.CSSProperties = { width: '100%', height: '31px', display: 'flex', flexDirection: 'row', backgroundColor: '#EAf3FF', borderTop: '1px solid #EAf3FF', borderBottom: '1px solid #EAf3FF' }
        var hoverstyle_selected: React.CSSProperties = { width: '100%', height: '31px', display: 'flex', flexDirection: 'row', backgroundColor: '#EAf3FF', borderTop: '1px solid #CAd3dF', borderBottom: '1px solid #CAd3dF' }
        var favStr = ""
        var extInfoArrowOffset = 7
        var extInfoArrowShow = false // If or not the ext info dropdown arrow should be displayed

        if ((this.state.mouseState != "hover") && (this.isSelected() == false)) {
            if (this.props.core.FavoritesFind(this.props.article.GetSelectionLabel())) {
                favStr = "url(images/ArtViewFavorites.png)"
            }
            else {
                favStr = "url(images/ArtViewFavoritesUnchecked.png)"
            }
        }
        else{
            if (this.props.core.FavoritesFind(this.props.article.GetSelectionLabel())) {
                favStr = "url(images/ArtViewFavoritesHover.png)"
            }
            else {
                favStr = "url(images/ArtViewFavoritesHoverUnchecked.png)"
            }
        }

        // When the selected article is being hovered, the arrow to collapse/expand the extended info will light up a bit
        if (this.state.mouseState == "hover") {
            hoverstyle = hoverstyle_hover
            extInfoArrowOffset += 68
        }

        // Only the selected article can have an arrow to hide/show the extended info
        if (this.isSelected()) {
            this.props.core.ConnectSelectedQRArticleItem(this)
            hoverstyle = hoverstyle_selected
            extInfoArrowShow = true
        }

        // If ext info is shown, the arrow will point upward as to show it can be hidden by clicking the article again
        if (this.props.core.GetApp().state.ExtInfoUp == true) {
            extInfoArrowOffset += 34
        }

        // turns the offset into a string that will be used to position the background image
        const bgPosition = "0px -" + extInfoArrowOffset.toString() + "px"

        var isVisible = (extInfoArrowShow == true) ? "visible" : "hidden"
        var extArrowStyle: React.CSSProperties = { width: "25px", height: "20px", backgroundImage: "url(images/UtvidetInfoLocalArrow.png)", backgroundPosition: bgPosition, visibility: isVisible, position: "relative", top: "4px", left: "0px" }
        
        return <div onMouseOut={this.onMouseOut.bind(this)}
            onMouseOver={this.onMouseOver.bind(this)}
            onMouseDown={this.onMouseDown.bind(this)}
            onMouseUp={this.onMouseUp.bind(this)}
            onClick={this.onClick.bind(this)}
            style={hoverstyle}>

            <div style={{ width: "5px" }}>
            </div>

            {/* Ext Info arrowdown area */}
            <div onClick={this.onClickCenter.bind(this)} style={extArrowStyle} >
            </div>

            <div style={{width:"5px"}}>
            </div>

            {/* Numeric control area */}
            <div style={{ width: "120px" }} >
                <ChoiseControlQreportGW core={this.props.core} selectionItem={this} />
            </div>

            {/* Central dynamic columns area */}
            <div onClick={this.onClickCenter.bind(this)} style={{ width: "calc(100% - 187px)", display: 'flex', flexDirection: 'row' }} >
                <div style={{ width: "1%" }}></div>
                <div style={{ width: "9%" }}>{art.GetUnit()}</div>
                <div style={{ width: "64%", display: "plex", direction: "column" }}>
                    <div style={{ position: "relative", top: "-2px" }}>{art.GetDescription()}</div>
                    <div style={{ position: "relative", top: "-2px" }}>{art.GetDescription2()}</div>
                </div>
                <div style={{ width: "13%" }}>{art.GetIdentifier()}</div>
                <div style={{ width: "calc(12% - 8px)", textAlign: "right" }}>{this.props.core.GetArticlePrizeString(art)}</div>
                <div style={{ width: "calc(12% - 8px)", textAlign: "right" }}>{art.GetSumString(this.props.core.GetPriceRadio(), this.props.core.GetPriceFlags())}</div>
                <div style={{ width: "calc(1% + 8px)" }}></div>
            </div>

            {/* Favorites star area */}
            <div
                style={{
                    width: "32px",
                    cursor: "pointer",
                    backgroundImage: favStr,
                }}
                onClick={this.onClickFavorites.bind(this)}>
            </div>
        </div>
    }

    m_choise: ChoiseControlQreportGW  // The numerical amount seting control shown to the left of the item
    m_clickedArea: string // This is set by the various controls being clicked, then reset to "none" in onClick for the entire item, after the click has been handled
}



// WEBPACK FOOTER //
// ./client/view/SelectionItemGW.tsx